import { render, staticRenderFns } from "./examIndex.vue?vue&type=template&id=8f313e0c"
import script from "./examIndex.vue?vue&type=script&lang=js"
export * from "./examIndex.vue?vue&type=script&lang=js"
import style0 from "./examIndex.vue?vue&type=style&index=0&id=8f313e0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports